import { TradeGlyph } from "@volca/ui/components/ui/trade-glyph";
import { cn } from "@volca/ui/lib/utils";
import { glyphFor } from "@volca/ui/trades";
import type { ReportObjectIcon } from "@/profitability/types";

const initials = (name: string, letters: number) =>
  name
    .split(/[\s-]+/)
    .filter(Boolean)
    .slice(0, letters)
    .map((word) => word[0]?.toUpperCase())
    .join("");

const SIZES = {
  sm: "size-5 text-xs [&_svg]:size-3.5",
  md: "size-7 text-xs [&_svg]:size-4",
  lg: "size-10 text-sm [&_svg]:size-5",
} as const;

/**
 * What a record is at a glance: a person is their initials in a circle, a
 * business unit its trade's glyph (a plug, a condensing unit, a drain), a job
 * the glyph of the trade it was done in. All in ink on a neutral tile: colour
 * on these screens is kept for status.
 */
export const RecordMark = ({
  icon,
  name,
  trade,
  size = "sm",
  className,
}: {
  icon: ReportObjectIcon;
  name: string;
  /** The business unit a job was done in, to draw its trade. */
  trade?: string | null;
  size?: keyof typeof SIZES;
  className?: string;
}) => {
  const person = icon === "person";
  return (
    <span
      aria-hidden
      className={cn(
        "inline-flex flex-none items-center justify-center border border-line bg-surface-sunken font-medium text-subtle select-none",
        SIZES[size],
        person ? "rounded-full" : "rounded-md",
        className,
      )}
    >
      {person ? (
        initials(name, size === "sm" ? 1 : 2)
      ) : (
        <TradeGlyph name={glyphFor(icon, icon === "team" ? name : trade)} />
      )}
    </span>
  );
};
